import Button from '~/client/shared/Button';
import Translate from '~/client/shared/i18n/Translate';
import ViewProgress from './ViewProgress';

type Props = {
  count: number;
  totalCount: number;
  loading: boolean;
  handleLoadMore: () => void;
};

const LoadMore: FC<Props> = ({
  handleLoadMore,
  count,
  totalCount,
  loading,
}) => {
  if (count >= totalCount) {
    return null;
  }

  return (
    <>
      <Button
        className="m-auto max-w-fit"
        onClick={handleLoadMore}
        animation={loading ? 'progress' : undefined}
        disabled={loading}
      >
        <Translate id="general.load_more" />
      </Button>
      <ViewProgress count={count} totalCount={totalCount} />
    </>
  );
};

export default LoadMore;
